import React, { useEffect, FC } from 'react'
import { SidebarContainer, SidebarOverlay } from './styles'

export type TSidebar = {
  isOpen: boolean
  onClose: () => void
  children: JSX.Element | JSX.Element[]
  isLeftSide?: boolean
}

const Sidebar: FC<TSidebar> = ({ isOpen, onClose, children, isLeftSide = false }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflowY = 'hidden'
    } else {
      document.body.removeAttribute('style')
    }

    if (!isOpen || !onClose) {
      return undefined
    }

    const listener: any = window.addEventListener('keyup', (event) => {
      if (event.key === 'Escape') {
        onClose()
      }
    })

    return () => {
      window.removeEventListener('keyup', listener)
    }
  }, [isOpen, onClose])

  const handleContainerClick = (event: React.MouseEvent) => event.stopPropagation()

  return (
    <>
      <SidebarOverlay isOpen={isOpen} />
      <SidebarContainer isOpen={isOpen} isLeftSide={isLeftSide} onClick={handleContainerClick}>
        {React.Children.map(children, (child: React.ReactElement) => React.cloneElement(child, { onClose }))}
      </SidebarContainer>
    </>
  )
}

export default Sidebar
